import { Avatar, Divider } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import Dine from "../../../../assets/images/order/dine.png";
import Togo from "../../../../assets/images/order/togo.png";
import Delivery from "../../../../assets/images/order/delivery.png";
import AddCus from "../../../../assets/images/order/add-customer.png";
import NoTable from "../../../../assets/images/order/no-table.png";
import Discart from "../../../../assets/images/order/discart.png";
import Discount from "../../../../assets/images/order/discount.png";
import Print from "../../../../assets/images/order/print.png";
import CardItem from "./CardItem";

const FlexDivRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const FlexDivRowSecondary = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  height: 30,
  margin: "0 20Px",
  fontSize: 14,
  fontWeight: "400",
  fontFamily: `Poppins, sans-serif`,
  color: "#424242",
}));

const FlexDivColumn = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const threebtn = [
  { title: "Dine In", icon: Dine },
  { title: "To Go", icon: Togo },
  { title: "Delivery", icon: Delivery },
];

const bottomThree = [
  { title: "Discart", icon: Discart, color: "#FFB2B6" },
  { title: "Discount Code", icon: Discount, color: "#FEFFE1" },
  { title: "Print", icon: Print, color: "#E4FFFF" },
];

const twobtn = [
  { title: "Add Customer", icon: AddCus },
  { title: "No Table", icon: NoTable },
];

const OrderLeftCard = () => {
  const [selectedIdx, setSelectedIdx] = React.useState(1);

  const handleTopMenu = (idx) => {
    setSelectedIdx(idx);
    console.log("lllll : " + idx);
  };

  return (
    <div style={{}}>
      <TopHeader />
      <TopThreeBtn selectedIdx={selectedIdx} handleTopMenu={handleTopMenu} />
      <TwoBtn />
      <div style={{ minHeight: 200, margin: "10px 20px" }}>
        {[1, 1].map((item, index) => (
          <CardItem />
        ))}
      </div>
      <Divider />
      <CalculationPart />
      <BottomThree />
    </div>
  );
};

const TopHeader = () => (
  <div
    style={{
      background: "#E5E5E5",
    }}
  >
    <FlexDivRow
      style={{
        height: 48,
        margin: "0 20Px",
        fontFamily: `Poppins, sans-serif`,
      }}
    >
      <div
        style={{
          fontSize: 18,
          fontWeight: "600",
        }}
      >
        Order #125
      </div>
      <div
        style={{
          fontSize: 10,
          fontWeight: "400",
        }}
      >
        Opened 12:00 PM
      </div>
    </FlexDivRow>
  </div>
);

const TopThreeBtn = ({ selectedIdx, handleTopMenu }) => (
  <FlexDivRow style={{ margin: "10px 20px" }}>
    {threebtn.map((item, index) => (
      <FlexDivColumn
        style={{
          width: 89,
          height: 64,
          background: `${index === selectedIdx ? "#FFB2B6" : "#E5E5E5"}`,
          borderRadius: 4,
          boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
          cursor: "pointer",
        }}
        onClick={() => handleTopMenu(index)}
      >
        <Avatar
          sx={{
            width: "26px",
            height: "26px",
          }}
          variant="square"
          src={item.icon}
        />
        <div
          style={{
            marginTop: 5,
            fontSize: 12,
            fontFamily: `Poppins, sans-serif`,
          }}
        >
          {item.title}
        </div>
      </FlexDivColumn>
    ))}
  </FlexDivRow>
);

const TwoBtn = () => (
  <FlexDivRow style={{ margin: "15px 20px" }}>
    {twobtn.map((item, index) => (
      <FlexDivColumn
        style={{
          width: 137,
          height: 64,
          background: "#FFF",
          border: "1px solid #C4C4C4",
          borderRadius: 4,
        }}
      >
        <Avatar
          sx={{
            width: "26px",
            height: "26px",
          }}
          variant="square"
          src={item.icon}
        />
        <div
          style={{
            marginTop: 5,
            fontSize: 12,
            fontFamily: `Poppins, sans-serif`,
          }}
        >
          {item.title}
        </div>
      </FlexDivColumn>
    ))}
  </FlexDivRow>
);

const CalculationPart = () => (
  <div>
    <div style={{ margin: "7px 0" }}>
      <FlexDivRowSecondary>
        <div>Sub Total</div>
        <div>TK 495</div>
      </FlexDivRowSecondary>

      <FlexDivRowSecondary>
        <div>Discount</div>
        <div>TK 5%</div>
      </FlexDivRowSecondary>
    </div>

    <div
      style={{
        background: "#E5E5E5",
      }}
    >
      <FlexDivRow
        style={{
          height: 48,
          margin: "0 20Px",
          fontSize: 18,
          fontWeight: "600",
          fontFamily: `Poppins, sans-serif`,
        }}
      >
        <div style={{}}>Total</div>
        <div
          style={{
            color: "red",
          }}
        >
          TK 500
        </div>
      </FlexDivRow>
    </div>
  </div>
);

const BottomThree = () => (
  <FlexDivRow style={{ margin: "15px 20px" }}>
    {bottomThree.map((item, index) => (
      <FlexDivColumn
        style={{
          width: 89,
          height: 78.48,
          background: item.color,
          borderRadius: 4,
          boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Avatar
          sx={{
            width: "26px",
            height: "26px",
          }}
          variant="square"
          src={item.icon}
        />
        <div
          style={{
            marginTop: 5,
            fontSize: 12,
            fontFamily: `Poppins, sans-serif`,
          }}
        >
          {item.title}
        </div>
      </FlexDivColumn>
    ))}
  </FlexDivRow>
);

export default OrderLeftCard;
